module.exports = __webpack_public_path__ + "img/hr-tree-04-f-leaves.dbc1e1bf.png";